/**
 * 所有接口api
 * method: get, post, delete, patch, put, head
 */
 import axios from './index';
 import {formatObjToUrl} from "../config/Utility";
 import fetch from './fetch';
 
 // 动态获取headers
 const getHeaders = () => {
	 return {
		 'Authorization': window.localStorage.getItem('token')
	 }
 };
 
 
 export default {
	 install(Vue) {
	   Vue.prototype.$ApiGet = function(pathurl,params,header={}){
		 return fetch({
			 url: pathurl,
			 method: 'get',
			 params,
			 headers: Object.assign({},getHeaders(),header) 
		 })
	  };
	  
	  Vue.prototype.$ApiPost = function(pathurl,data,header={}){
		 return fetch({
			 url: pathurl,
			 method: 'post',
			 data,
			 headers: Object.assign({},getHeaders(),header) 
		 })
	  };
 
   }
 }
 
 
 
 


// WEBPACK FOOTER //
// ./src/axios/api.js